import { HttpMethod } from "../common/lib/fetch/useFetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";
import useUserRequest from "../common/lib/fetch/useUserRequest";

const useLoadingCompleted = (stagedOrderId: string, options?: RequestOptions) =>
  useUserRequest<void>({
    method: HttpMethod.POST,
    path: `/api/stagedOrders/${stagedOrderId}/loadingCompleted`
  }, options);

export default useLoadingCompleted;
